import { Suspense } from "react";

import "./App.scss";
import AppConfig from "config/AppConfig";
import ApiProvider from "./api/ApiProvider";
import AppRoutes from "./AppRoutes";
import { AgxAuth } from "@urbanx/agx.auth.client";
import { applyTheme } from "@urbanx/agx.ui-components2";
import "@urbanx/agx.ui-components2/index.css";

applyTheme({
  main: [
    { scalePosition: 50, hexValue: "#f3f7fc", isBaseColour: false },
    { scalePosition: 100, hexValue: "#e7eef7", isBaseColour: false },
    { scalePosition: 200, hexValue: "#c9dbee", isBaseColour: false },
    { scalePosition: 300, hexValue: "#99bee0", isBaseColour: false },
    { scalePosition: 400, hexValue: "#639bcd", isBaseColour: false },
    { scalePosition: 500, hexValue: "#3f7fb8", isBaseColour: true },
    { scalePosition: 600, hexValue: "#2e649b", isBaseColour: false },
    { scalePosition: 700, hexValue: "#26517e", isBaseColour: false },
    { scalePosition: 800, hexValue: "#234569", isBaseColour: false },
    { scalePosition: 900, hexValue: "#223b58", isBaseColour: false },
    { scalePosition: 950, hexValue: "#17263a", isBaseColour: false },
  ],
  accent: [
    { scalePosition: 50, hexValue: "#faf5f0", isBaseColour: false },
    { scalePosition: 100, hexValue: "#efe3d6", isBaseColour: false },
    { scalePosition: 200, hexValue: "#dec5a9", isBaseColour: false },
    { scalePosition: 300, hexValue: "#cda57c", isBaseColour: false },
    { scalePosition: 400, hexValue: "#c18b5e", isBaseColour: false },
    { scalePosition: 500, hexValue: "#ba7a55", isBaseColour: true },
    { scalePosition: 600, hexValue: "#a05a3f", isBaseColour: false },
    { scalePosition: 700, hexValue: "#864437", isBaseColour: false },
    { scalePosition: 800, hexValue: "#6e3932", isBaseColour: false },
    { scalePosition: 900, hexValue: "#5c302b", isBaseColour: false },
    { scalePosition: 950, hexValue: "#331715", isBaseColour: false },
  ],
});

const ReleasesApp = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <AgxAuth apiConfig={AppConfig}>
        <ApiProvider>
          <AppRoutes />
        </ApiProvider>
      </AgxAuth>
    </Suspense>
  );
};

export default ReleasesApp;
